//Breakpoints for TOP window
export enum Breakpoint {
	XS = 360,
	SM = 600,
	MD = 768,
	LG = 1024,
	XL = 1440,
}

//Width of the TOP window breakpoints
export const BreakpointWidths = {
	SM: 600,
	MD: 768,
	LG: 1024,
	XL: 1440,
};

export enum DeviceType {
	Desktop = 'desktop',
	Mobile = 'mobile',
}

export const MAX_CONTENT_WIDTH = 1920;

export const getCurrentBreakpoint = (topWindowWidth?: number): number => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const currentWidth = topWindowWidth || window.top.innerWidth;

	if (currentWidth < Breakpoint.SM) {
		return Breakpoint.XS;
	} else if (currentWidth < Breakpoint.MD) {
		return Breakpoint.SM;
	} else if (currentWidth < Breakpoint.LG) {
		return Breakpoint.MD;
	} else if (currentWidth < Breakpoint.XL) {
		return Breakpoint.LG;
	} else {
		return Breakpoint.XL;
	}
};

export const getDevice = (currentBreakpoint: string): DeviceType => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return isDesktop(Breakpoint[currentBreakpoint])
		? DeviceType.Desktop
		: DeviceType.Mobile;
};

export const isDesktop = (currentBreakpoint: number): boolean => {
	const desktopBreakpoints = [Breakpoint.LG, Breakpoint.XL];

	return desktopBreakpoints.includes(currentBreakpoint);
};

export const isMobile = (currentBreakpoint: number): boolean => {
	const desktopBreakpoints = [Breakpoint.XS, Breakpoint.SM, Breakpoint.MD];

	return desktopBreakpoints.includes(currentBreakpoint);
};
